import Vue from "vue";
// @ts-ignore
import App from "../src/App.vue";
import router from "@/router";
import store from "@/store";
import vuetify from "@/plugins/vuetify";
var excel = require("vue-excel-export");
import { getModule } from "vuex-module-decorators";
import UserModule from "@/store/userModule.ts";
import { library } from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import moment from "moment";

Vue.component("font-awesome-icon", FontAwesomeIcon);

Vue.config.productionTip = false;

Vue.filter("formatDate", function(value: string) {
  if (value) {
    return moment(String(value)).format("DD/MM/YYYY");
  }
});

Vue.filter("formatNewLines", (value: string) => {
  if (!value) return "";
  return value.replace(/\\n/g, "\n");
});

new Vue({
  router,
  store,
  created() {
    const tokenString: string | null = localStorage.getItem("token");
    if (tokenString) {
      const token = JSON.parse(tokenString);
      const userModule = getModule(UserModule);
      userModule.setUserData(token);
    }
  },
  vuetify,
  render: h => h(App)
}).$mount("#app");
